import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0e593476"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header-info"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("关闭");

import { computed, ref } from 'vue';
import { getPrizeExpireList } from '@/request';
export default {
  name: 'PrizeExpireDetailModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const loading = ref(false);
    const tableData = ref([]);

    function formatPrice(price) {
      if (price === null || price === undefined || price === '') {
        return '-';
      }

      return Number(price).toFixed(2);
    }

    function formatNum(val) {
      if (val === null || val === undefined || val === '') {
        return '0';
      }

      return Number(val).toString();
    }

    function loadExpireList() {
      var _props$row;

      tableData.value = [];

      if (!((_props$row = props.row) !== null && _props$row !== void 0 && _props$row.merchandiseCansaleId)) {
        return;
      }

      loading.value = true;
      getPrizeExpireList({
        merchandiseCansaleId: props.row.merchandiseCansaleId,
        excludeExpired: true,
        __warn: true
      }).then(data => {
        tableData.value = data.rows || [];
      }).finally(() => {
        loading.value = false;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "效期明细",
        width: "720px",
        "destroy-on-close": "",
        onOpen: loadExpireList
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => {
          var _props$row2, _props$row3, _props$row4;

          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, "商品名称：" + _toDisplayString(((_props$row2 = __props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.prodName) || '-'), 1), _createElementVNode("span", null, "规格：" + _toDisplayString(((_props$row3 = __props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.prodSpecification) || '-'), 1), _createElementVNode("span", null, "价格：" + _toDisplayString(formatPrice((_props$row4 = __props.row) === null || _props$row4 === void 0 ? void 0 : _props$row4.price)), 1)]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: tableData.value,
            border: "",
            "max-height": "360"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "效期",
              "min-width": "160",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({
                row: item
              }) => [_createTextVNode(_toDisplayString(item.expireText || '-'), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "库存",
              width: "110"
            }, {
              default: _withCtx(({
                row: item
              }) => [_createTextVNode(_toDisplayString(formatNum(item.storageNumber)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "预占库存",
              width: "110"
            }, {
              default: _withCtx(({
                row: item
              }) => [_createTextVNode(_toDisplayString(formatNum(item.depositStorageNumber)), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "剩余数量",
              width: "110"
            }, {
              default: _withCtx(({
                row: item
              }) => [_createTextVNode(_toDisplayString(formatNum(item.leftNum)), 1)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])), [[_directive_loading, loading.value]])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};